import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";
import ScrollToTop from "../../../components/scroll-to-top";
import {
  FiHeart,
  FiEye,
  FiBookmark,
  FiChevronLeft,
  FiChevronRight,
} from "../../../assets/icons/vander";
import { newProduct } from "../../../data/data";
import { useGetAllProductsQuery } from "../../../redux/services/products";
import Pagination from "../../../components/pagination";
import { createClient } from "../../../utils/supbase/client";
import { getProductColor, transformObject } from "../../../utils/helper";
import { useAddItemtoCartMutation } from "../../../redux/services/cart";
import { useSelector } from "react-redux";
import { noResult } from "../../../assets/images/imports";
import NoItemsFound from "../../../components/noItemsFound";
import { toast } from "react-toastify";
import SizeSelector from "../../../components/size-selector";
import { useAddItemtoWishlistMutation } from "../../../redux/services/wishlist";
import { GET_PRODUCTS } from "../../../redux/graphQL/products";
import { useQuery } from "@apollo/client";

export default function ShopList() {
  const supabase = createClient();
  const [pageNumber, setPageNumber] = useState(1);
  const pageLimit = 10;
  const offset = (pageNumber - 1) * pageLimit;
  const user = useSelector((state)=> state.auth.user)
  const { data: allProductsData } = useQuery(GET_PRODUCTS, {
    variables: {
      user_id: user?.id,
      offset: offset,
      limit: pageLimit,
    }
  });
  const [addProductToCart , { data, isLoading }] = useAddItemtoCartMutation()
  const [addProductToWishlist] = useAddItemtoWishlistMutation();
  const [totalItems, setTotalItems] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get("search");
  const [selectedColors, setSelectedColors] = useState({});
  const [selectedSizes, setSelectedSizes] = useState({});
  const [allProducts, setAllProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    const getTotalProducts = async () => {
      const { data: countData, error: countError } = await supabase.rpc(
        "products_count"
      );

      if (countError) {
        throw countError;
      } else if (countData) {
        setTotalItems(countData);
      }
    };

    getTotalProducts();
  }, []);

  useEffect(() => {
    if (allProducts?.length) {
      allProducts.forEach(element => {
        element.wishlist.forEach(item => {
          if (isUserIdPresent(element.wishlist) && !wishlist.includes(item.product_id)) {
            setWishlist(prev => [...prev, item.product_id]);
          }
        });
      });
    }
  }, [allProducts, wishlist]);

  useEffect(() => {
    if (allProductsData?.productsCollection?.edges?.length) {
      setAllProducts(transformObject(allProductsData).productsCollection);
    }
  }, [allProductsData]);

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleAddToCart= async (details)=>{
    if (!user?.id) {
      toast.warning("Please login to add to cart");
      return;
    }
    await addProductToCart({
      quantity: 1,
      product_id: details.id,
      user_id: user.id,
      selected_color: selectedColors[details.id],
      selected_size: selectedSizes[details.id]
    })
    toast.success("Product added to cart");
  }

  const handleColorSelect = (productId, color) => {
    setSelectedColors(prev => ({
      ...prev,
      [productId]: color
    }));
  };

  const handleHeartClick = async (e, details) => {
    e.stopPropagation();
    if (!user?.id) {
      toast.warning("Please login to add to wishlist");
      return;
    }
    if (isUserIdPresent(details.wishlist)) {
      toast.warning("Product already added to wishlist");
    } else {
      await addProductToWishlist({
        product_id: details.id,
        user_id: user.id,
      })
      setWishlist((prev)=> [...prev, details.id])
      toast.success("Product added to Wishlist !");
    }
  }

  function isUserIdPresent(records) {
    for (let record of records) {
      if (record.user_id === user?.id || wishlist.includes(record.product_id)) {
        return true;
      }
    }
    return false;
  }

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative table w-full py-20 lg:py-24 md:pt-28 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 mt-14">
            <h3 className="text-3xl leading-normal font-semibold">{searchQuery ?? "Fashion"}</h3>
          </div>

          <div className="relative mt-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                <Link to="/">TAS e store</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li
                className="inline-block uppercase text-[13px] font-bold text-orange-500"
                aria-current="page"
              >
                Shop List
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-6">
            {allProducts?.filter((item) => searchQuery ? item.title.toLowerCase().includes(searchQuery.toLowerCase()) : true).length === 0 ? (
              <NoItemsFound />
            ) : (
              allProducts?.filter((item) => searchQuery ? item.title.toLowerCase().includes(searchQuery.toLowerCase()) : true).map((item, index) => {
                return (
                  <div
                    className="group relative duration-500 w-full mx-auto"
                    key={index}
                  >
                    <div className="md:flex items-center">
                      <div className="relative overflow-hidden md:shrink-0 shadow dark:shadow-gray-800 group-hover:shadow-lg group-hover:dark:shadow-gray-800 rounded-md duration-500">
                        <img
                          className="h-full w-full object-cover md:w-48 rounded-md group-hover:scale-110 duration-500"
                          src={item.image_urls[0]}
                          alt=""
                        />
                        <ul className="list-none absolute top-[10px] end-4 opacity-0 group-hover:opacity-100 duration-500 space-y-1">
                          <li>
                            <button
                              onClick={(e)=> handleHeartClick(e,item)}
                              className={`size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white ${isUserIdPresent(item.wishlist) || wishlist.includes(item.id) ? "text-orange-600" : "text-slate-900"} hover:bg-slate-900 hover:text-white shadow`}
                            >
                              <FiHeart className="size-4"></FiHeart>
                            </button>
                          </li>
                          <li className="mt-1 ms-0">
                            <Link
                              to={`/product-detail-three/${item.id}`}
                              className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                            >
                              <FiEye className="size-4"></FiEye>
                            </Link>
                          </li>
                          {/* <li className="mt-1 ms-0">
                            <Link
                              to="#"
                              className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                            >
                              <FiBookmark className="size-4"></FiBookmark>
                            </Link>
                          </li> */}
                        </ul>

                        <ul className="list-none absolute top-[10px] start-4">
                                              {item.offer === true && (

                                                  <li><Link to="#" className="bg-orange-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                              )}
                                              {item.tag === 'New' && (
                                                  <li><Link to="#" className="bg-red-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                              )}
                                              {item.tag === 'Featured' && (
                                                  <li><Link to="#" className="bg-emerald-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                              )}
                                          </ul>
                      </div>
                      <div className="md:ms-6 md:mt-0 mt-4">
                        <Link
                          to={`/product-detail-three/${item.id}`}
                          className="hover:text-orange-500 text-lg font-medium"
                        >
                          {item.title}
                        </Link>
                        <p className="text-slate-400 mt-2 line-clamp-2 text-ellipsis ">
                          {item.description}
                        </p>
                        <p className="mt-2">{item.desRate}</p>

                        <ul className="list-none mt-2 space-x-1">
                          {item.color?.map((col, idx) => {
                            return (
                              <li key={idx} className="inline">
                                <button 
                                  onClick={() => handleColorSelect(item.id, col)}
                                  style={{background: col}} 
                                  className={`size-6 rounded-full ring-2 ${selectedColors[item.id] === col ? 'ring-orange-500' : 'ring-gray-200 dark:ring-slate-800'} inline-flex align-middle transition-all`}
                                  title={col}
                                />
                              </li>
                            )
                          })}
                        </ul>

                        {item.size?.length > 0 && (
                          <div className="mt-2">
                            <SizeSelector getSelectedSize={setSelectedSizes} sizes={item.size} componentSize="sm" />
                          </div>
                        )}

                        <button
                          onClick={()=> handleAddToCart(item)}
                          className="mt-4 py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center bg-slate-900 dark:bg-slate-800 text-white rounded-md shadow dark:shadow-gray-700"
                        >
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {totalItems > pageLimit && !searchQuery && <Pagination
            currentPage={pageNumber}
            totalItems={totalItems}
            itemsPerPage={pageLimit}
            onPageChange={handlePageChange}
          />}

          
        </div>
      </section>
      <Footer />
      {/* <Switcher/> */}
      <ScrollToTop />
    </>
  );
}
